import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function stepStatus() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`stepstatus/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`stepstatus/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('stepstatus/create', data);
    }

    function update(data) {
        return axiosInstance.patch('stepstatus/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`stepstatus/delete`, {
            data: {
                id: id
            }
        });
    }
}
